import { es } from 'yup-locales'

export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return

  yup.setLocale(es)
})
